import { SheetFactory } from './sheetFactory';

import type {
  SheetEntity,
  SheetPropsPub,
  SheetPropsPvt,
} from './sheetEntity';
import type { SheetIRepository } from './sheetIRepository';
import type { EntityDataPubType } from '@/infra/appsync';
import type { SheetJsonPub, SheetJsonPvt } from '@/types/domain/attendance/entities/sheetEntity';

import { AppsyncRepository } from '@/domain/appsyncRepository';
import {
  EntityName,
} from '@/infra/appsync';

export class SheetRepository extends AppsyncRepository<
  SheetEntity,
  SheetPropsPvt,
  SheetJsonPvt,
  SheetPropsPub,
  SheetJsonPub
> implements SheetIRepository {
  private factory = new SheetFactory();

  protected get entityName(): EntityName {
    const name: EntityName = EntityName.WagakoNurseryAttendanceSheetEntity;
    return name;
  }

  /**
   * DBデータをEntityに変換
   * @param props DBデータ
   * @returns Entity
   */
  protected createFromEntityType = (
    props: EntityDataPubType,
  ) => this.factory.createFromEntityType(props);
}
